import DialogTitle from '@mui/material/DialogTitle';
import type { ReactNode } from 'react';

import styles from './portal-dialog.module.css';

interface PortalDialogTitleProps {
  title: ReactNode;
  titleIcon?: ReactNode;
}

export function PortalDialogTitle({
  title,
  titleIcon,
}: PortalDialogTitleProps) {
  return (
    <DialogTitle sx={{ m: 0, p: 2 }}>
      <div className={styles['dialog-title']}>
        {titleIcon && (
          <div className={styles['dialog-title-icon']}>{titleIcon}</div>
        )}
        {title}
      </div>
    </DialogTitle>
  );
}
